export const vipLevelEnum = [
    {
        stateId: "L1",
        stateName: "普通会员"
    },
    {
        stateId: "L2",
        stateName: "月度会员"
    },
    {
        stateId: "L3",
        stateName: "年度会员"
    },
    {
        stateId: "L4",
        stateName: "SVIP"
    },
    {
        stateId: "L5",
        stateName: "PERMIER"
    },
    {
        stateId: "L6",
        stateName: "L6"
    },
    {
        stateId: "L7",
        stateName: "L7"
    },
]
